/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DateRange } from './DateRange';
import {
    DateRangeFromJSON,
    DateRangeFromJSONTyped,
    DateRangeToJSON,
    DateRangeToJSONTyped,
} from './DateRange';
import type { RequestInfoProvider } from './RequestInfoProvider';
import {
    RequestInfoProviderFromJSON,
    RequestInfoProviderFromJSONTyped,
    RequestInfoProviderToJSON,
    RequestInfoProviderToJSONTyped,
} from './RequestInfoProvider';
import type { RequestInfoSubscriber } from './RequestInfoSubscriber';
import {
    RequestInfoSubscriberFromJSON,
    RequestInfoSubscriberFromJSONTyped,
    RequestInfoSubscriberToJSON,
    RequestInfoSubscriberToJSONTyped,
} from './RequestInfoSubscriber';

/**
 * 
 * @export
 * @interface RequestInfo
 */
export interface RequestInfo {
    /**
     * 
     */
    provider?: RequestInfoProvider;
    /**
     * 
     */
    date_range?: DateRange;
    /**
     * 
     */
    subscriber?: RequestInfoSubscriber;
}

/**
 * Check if a given object implements the RequestInfo interface.
 */
export function instanceOfRequestInfo(value: object): value is RequestInfo {
    return true;
}

export function RequestInfoFromJSON(json: any): RequestInfo {
    return RequestInfoFromJSONTyped(json, false);
}

export function RequestInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'provider': json['provider'] == null ? undefined : RequestInfoProviderFromJSON(json['provider']),
        'date_range': json['date_range'] == null ? undefined : DateRangeFromJSON(json['date_range']),
        'subscriber': json['subscriber'] == null ? undefined : RequestInfoSubscriberFromJSON(json['subscriber']),
    };
}

export function RequestInfoToJSON(json: any): RequestInfo {
    return RequestInfoToJSONTyped(json, false);
}

export function RequestInfoToJSONTyped(value?: RequestInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'provider': RequestInfoProviderToJSON(value['provider']),
        'date_range': DateRangeToJSON(value['date_range']),
        'subscriber': RequestInfoSubscriberToJSON(value['subscriber']),
    };
}

